<script setup lang="ts">
import { useFormComposable } from '@src/form/composables/form-composable.js';
import Select from '@components/form/select.vue';
import { ref } from 'vue';
import apiClient from '@src/api/api-client.js';
import { Printer } from '@src/printer/interfaces/printer.js';
import { ModelValuePropsInterface, useModelValueComposable, ModelValueEmitsType } from '@components/form/compsables/model-value-composable.ts';
import { loadOnBeforeMount } from '@utils/load-util.ts';
import { PrinterSettings } from '@src/application/interfaces/printer-settings.ts';

defineProps<ModelValuePropsInterface<PrinterSettings>>();

const { modelValue, exposes: modelValueExposes } = useModelValueComposable<PrinterSettings>();

const emit = defineEmits<ModelValueEmitsType<PrinterSettings> & {
    (event: 'submit', payload: PrinterSettings): void,
}>();

const { form, exposes: formExposes } = useFormComposable(modelValue, () => {
    if (modelValue.value === null) {
        throw new Error('modelValue is null');
    }
    emit('submit', modelValue.value);
});

const zplPrinters = ref<Array<Printer>>([]);
const eposPrinters = ref<Array<Printer>>([]);
const pdfPrinters = ref<Array<Printer>>([]);
const shippinglabelPrinters = ref<Array<Printer>>([]);

loadOnBeforeMount(async () => {
    const data: Array<Printer> = (await apiClient.get('/be/client-settings-get-printers')).data;
    zplPrinters.value = data.filter((f) => f.type === 'zpl');
    eposPrinters.value = data.filter((f) => f.type === 'epos');
    pdfPrinters.value = data.filter((f) => f.type === 'pdf');
    shippinglabelPrinters.value = data.filter((f) => f.type === 'shippinglabel');
});

defineExpose({ ...formExposes, ...modelValueExposes });
</script>

<template>
    <div>
        <Select
            name="zplPrinter.idPrinter"
            :required="false"
            label="ZPL"
            :form="form"
            :options="zplPrinters"
            label-property="name"
            value-property="idPrinter"
        />
        <Select
            name="eposPrinter.idPrinter"
            :required="false"
            label="EPOS (Bon)"
            :form="form"
            :options="eposPrinters"
            label-property="name"
            value-property="idPrinter"
        />
        <Select
            name="pdfPrinter.idPrinter"
            :required="false"
            label="PDF"
            :form="form"
            :options="pdfPrinters"
            label-property="name"
            value-property="idPrinter"
        />
        <Select
            name="shippinglabelPrinter.idPrinter"
            :required="false"
            label="Versandaufkleber"
            :form="form"
            :options="shippinglabelPrinters"
            label-property="name"
            value-property="idPrinter"
        />
    </div>
</template>
